import { render, staticRenderFns } from "./BenchmarkChart.vue?vue&type=template&id=1f1637a9&scoped=true&"
import script from "./BenchmarkChart.vue?vue&type=script&lang=js&"
export * from "./BenchmarkChart.vue?vue&type=script&lang=js&"
import style0 from "./BenchmarkChart.vue?vue&type=style&index=0&id=1f1637a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1637a9",
  null
  
)

export default component.exports